module.exports = __webpack_public_path__ + "img/icon-yuan-2.e87c506e.png";